import script from "./ShowTestsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowTestsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ShowTestsComponent.vue?vue&type=style&index=0&id=9a40a38a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a40a38a"]])

export default __exports__